import React from "react";
import "./about.css";

function About() {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="about-title">About Me</h2>
        <p className="about-text">
          Hi, I'm Zack. I'm a computer science enthusiast, with a particular passion towards complex mechanics and systems. I enjoy taking on projects that challenge me, and can blend that technical difficulty with a creative outlet, 
          whether that be web development, procedural terrain generation, game design, or any other challenge that catches my eye. My goal is to continue improving as a developer and programmer, and to create something truly special.

        </p>
        <p className="about-text">
          I am hoping to go into software development of any kind. I am particularly interested in game development, but any position where I can challenge myself and get to be creative is right up my alley. I am well versed in Unity, C#, C++, HTML, CSS, JavaScript,
           and have experience in many other languages such as Java, PiCat, Go, Swift, and SQL to name a few.
        </p>
        <p className="about-text">
          When I'm not coding, I enjoy designing games, playing games, D&D, and a little dabble in cooking.
        </p>
      </div>
    </section>
  );
}

export default About;